/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import browser from "../../utils/browser";

/**
 * Carousel Mixin
 *
 * Implements a simple horizontal carousel.
 *
 * Features:
 *    - show/hide scroll buttons when scroll extremes are reached
 *    - dynamically creates paging relative to container width and scroll width
 *    - highlight current page
 *
 * Required elements:
 *      .*__scroll-list`;
 *      .*__scroll-button--next`;
 *      .*__scroll-button--previous`;
 *      .*__paging`;
 *
 * Absence of any of these will throw an error
 *
 * Required style classes:
 *      *__scroll-button--disabled`, used to hide the scroll button
 *      *__page`, individual page style
 *      *__page--active`, active page style
 *
 * Example markup:
 *
 * <div class="my-component" is="my-component">
 *     <div class="my-component__carousel">
 *         <div class="my-component__scroll-container">
 *             <ul class="my-component__scroll-list">
 *                 <li></li>...
 *             </ul>
 *         </div>
 *         <button class="my-component__scroll-button my-component__scroll-button--previous my-component__scroll-button--disabled">
 *             Previous
 *         </button>
 *         <button class="my-component__scroll-button my-component__scroll-button--next ">
 *             Next
 *         </button>
 *     </div>
 *     <div class="my-component__paging"></div>
 * </div>
 *
 * Any additional styling is left as an exercise for the reader.
 */

export default {
    componentName: "",

    init() {
        this.dom = {
            scrollList: null,
            nextButton: null,
            prevButton: null,
            paging: null
        };

        this.classes = {
            hideButton: `${this.componentName}__scroll-button--disabled`,
            page: `${this.componentName}__page`,
            activePage: `${this.componentName}__page--active`
        };

        this.findElemements();
        this.calculateScroll();
        this.showOrHideFilterNavigation();
        this.bindEvents();
    },

    findElemements() {
        const SCROLL_LIST = `.${this.componentName}__scroll-list`;
        const NEXT_SELECTOR = `.${this.componentName}__scroll-button--next`;
        const PREVIOUS_SELECTOR = `.${this.componentName}__scroll-button--previous`;
        const PAGING = `.${this.componentName}__paging`;

        this.dom.scrollList = this.el.querySelector(SCROLL_LIST);
        this.dom.nextButton = this.el.querySelector(NEXT_SELECTOR);
        this.dom.prevButton = this.el.querySelector(PREVIOUS_SELECTOR);
        this.dom.paging = this.el.querySelector(PAGING);

        Object.keys(this.dom).forEach(key => {
            if (this.dom[key] === null) {
                throw new Error(
                    `The component
                    ${this.componentName}
                    is missing the necessary
                    ${key}
                    element which is required by carousel mixin`
                );
            }
        });
    },

    bindEvents() {
        this.dom.nextButton.addEventListener("click", () => {
            this._transformFilters(this.scrollAmount);
        });

        this.dom.prevButton.addEventListener("click", () => {
            this._transformFilters(this.scrollAmount * -1);
        });

        this.dom.scrollList.addEventListener("scroll", () => this.showOrHideFilterNavigation());

        window.addEventListener("resize", _.debounce(this.calculateScroll.bind(this)));
    },

    calculateScroll() {
        const item = this.dom.scrollList.querySelector("li");
        this.scrollAmount = item ? item.offsetWidth * 2 : 200;
        this._paging();
    },

    showOrHideFilterNavigation() {
        const list = this.dom.scrollList;
        const isBeginningOfScroll = list.scrollLeft === 0;
        const isEndOfScroll = Math.ceil(list.scrollLeft + list.offsetWidth) === list.scrollWidth;

        if (isBeginningOfScroll) {
            this.dom.prevButton.classList.add(this.classes.hideButton);
        } else {
            this.dom.prevButton.classList.remove(this.classes.hideButton);
        }

        if (isEndOfScroll) {
            this.dom.nextButton.classList.add(this.classes.hideButton);
        } else {
            this.dom.nextButton.classList.remove(this.classes.hideButton);
        }
        this._paging();
    },

    _transformFilters(scrollAmount) {
        if (!this.currentlyScrolling) {
            this.currentlyScrolling = true;
            const list = this.dom.scrollList;
            browser.animate(list, "scrollLeft", scrollAmount, 300).then(() => {
                // Enable interactions again.
                this.currentlyScrolling = false;
                this.showOrHideFilterNavigation();
            });
        }
    },

    _paging() {
        const list = this.dom.scrollList;
        const pages = Math.ceil(list.scrollWidth / this.scrollAmount);
        const page = list.scrollLeft == 0 ? 0 : Math.ceil(list.scrollLeft / this.scrollAmount);

        let pageMarkup = "";
        for (let i = 0; i < pages; i++) {
            let active = i === page ? this.classes.activePage : "";
            pageMarkup += `<div class="${this.classes.page} ${active}"></div>`;
        }

        this.dom.paging.innerHTML = pageMarkup;
    }
};

